import { useMutation } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';

import { gql } from '../../../generated';
import { RegisterRestorePasswordMutationVariables, RestorePasswordMutationVariables } from '../../../generated/graphql';

const REGISTER_RESTORE_PASSWORD = gql(/* GraphQL */ `
  mutation RegisterRestorePassword($email: String!) {
    usersRegisterRestorePassword(email: $email)
  }
`);

const RESTORE_PASSWORD = gql(/* GraphQL */ `
  mutation RestorePassword($token: String!, $password: String!) {
    usersRestorePassword(token: $token, password: $password)
  }
`);

export const useRestorePassword = () => {
  const [registerRestorePassword] = useMutation(REGISTER_RESTORE_PASSWORD, {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
    onCompleted: async (response) => {
      enqueueSnackbar('Success', {
        variant: 'success',
      });
    },
    context: {
      noAuth: true,
    },
  });

  const [restorePassword] = useMutation(RESTORE_PASSWORD, {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
    onCompleted: async (response) => {
      enqueueSnackbar('Success', {
        variant: 'success',
      });
    },
    context: {
      noAuth: true,
    },
  });

  return {
    registerRestorePassword: async (variables: RegisterRestorePasswordMutationVariables) => {
      const result = await registerRestorePassword({ variables });

      return result.data;
    },
    restorePassword: async (variables: RestorePasswordMutationVariables) => {
      const result = await restorePassword({ variables });

      return result.data;
    },
  };
};
